<template>
	<div>
		<FormulateInput
			class="col-12 px-0 mb-3 small"
			:class="additionalClasses"
			type="checkbox"
			name="donation-offer"
			validation="required"
			:validation-messages="{
				required: `${$t('agreementRequired')}`
			}"
			data-action="donation-offer"
		>
			<template #label="{ id }">
				<label :for="id" class="ml-2">
					Отправляя форму, я
					<a
						:href="href"
						target="_blank"
					>
						принимаю условия Публичной оферты *
					</a>
				</label>
			</template>
		</FormulateInput>
	</div>
</template>

<script>
export default {
	name: 'DonationAgreementInput',
	props: {
		additionalClasses: {
			type: String,
			default: '',
		},
		href: {
			type: String,
			default: '',
		},
	},
};
</script>

<style scoped>

</style>
